import { createImageVariantConfig } from './sdkLoader';

// Shared by the existing photos form and the optional photo preparation wrapper.
export const uploadListingImage = (sdk, file, listingImageConfig) => {
  const { aspectWidth = 1, aspectHeight = 1, variantPrefix = 'listing-card' } = listingImageConfig;
  const aspectRatio = aspectHeight / aspectWidth;
  return sdk.images.upload(
    { image: file },
    {
      expand: true,
      'fields.image': [`variants.${variantPrefix}`, `variants.${variantPrefix}-2x`],
      ...createImageVariantConfig(variantPrefix, 400, aspectRatio),
      ...createImageVariantConfig(`${variantPrefix}-2x`, 800, aspectRatio),
    }
  );
};
